module.exports = __webpack_public_path__ + "media/product_quotes/screen_bg-70994bd3.png";